var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"overdue-reminder"},[_c('WarningOutline16',{staticClass:"overdue-reminder__icon"}),_vm._v(" "),_c('p',{staticClass:"overdue-reminder__text"},[_vm._v("\n    "+_vm._s(_vm.overdueText)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }